const getLineCount = (element) => {
    const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
    const height = element.clientHeight;
    return Math.round(height / lineHeight);
  };

export default getLineCount;